<template>
  <div>
    <p>An error occurred while processing the request.</p>
    <pre>{{message}}</pre>
  </div>
</template>

<script>
  export default {
    name: 'error',
    computed: {
      message() {
        return this.$route.params.message;
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/views/ErrorMsg.vue